<template>
    <div id="ComponentModalCriarProcessoERegistro">
        <div class="modal fade modern-modal" id="ModalCriarProcessoERegistro" tabindex="-1" data-bs-focus="false">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-grande">
                <div class="modal-content modal-modern-content border-0">

                    <button type="button"
                            class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            :disabled="loading"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>

                        <div class="header-text">
                            <h2>Criar Processo + Solicitar Registro de Necessidade</h2>
                            <p v-if="activeTab === 'processo'">Informe os dados do processo.</p>
                            <p v-else>Selecione os setores responsáveis e adicione os itens com unidade de medida.</p>
                        </div>

                        <div class="header-status">
                            <div class="tabs-row">
                                <button class="tab-btn"
                                        :class="{ active: activeTab === 'processo' }"
                                        @click="activeTab = 'processo'">
                                    Processo
                                </button>

                                <button class="tab-btn"
                                        :class="{ active: activeTab === 'solicitacao', blocked: activeTab !== 'solicitacao' && !processoOk }"
                                        @click="irParaSolicitacao">
                                    Solicitação + Itens
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <!-- ===================== ABA PROCESSO ===================== -->
                        <div v-show="activeTab === 'processo'">
                            <div class="form-grid form-grid-3">
                                <div class="form-group">
                                    <label class="form-label">Número do Processo</label>
                                    <input type="text" class="form-control"
                                           v-model="cdProcessoNumero"
                                           :class="{ 'border-danger': camposInvalidos.cdProcessoNumero }"
                                           maxlength="50" />
                                </div>
                                <div class="form-group">
                                    <label class="form-label">Legislação</label>
                                    <select class="form-control"
                                            v-model="legislacaoSelecionadaId"
                                            :class="{ 'border-danger': camposInvalidos.legislacaoSelecionadaId }">
                                        <option disabled value="">Selecione uma Legislação</option>
                                        <option v-for="leg in (legislacoes || [])"
                                                :key="leg.idLegislacao"
                                                :value="String(leg.idLegislacao)">
                                            {{ leg.dsNome }}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Tipo de Processo</label>
                                    <select class="form-control"
                                            v-model="ProcessoSelecionadoId"
                                            :class="{ 'border-danger': camposInvalidos.ProcessoSelecionadoId }">
                                        <option disabled value="">Selecione um Tipo</option>
                                        <option v-for="proc in (tiposProcessos || [])"
                                                :key="proc.idTipoProcesso"
                                                :value="String(proc.idTipoProcesso)">
                                            {{ proc.nmTipoProcesso }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <SelectWorkflowProcesso v-model="idProcessoWorkflowSelecionado"
                                                    select-id="workflowProcessoERegistro"
                                                    :id-legislacao="legislacaoSelecionadaId"
                                                    :id-tipo-processo="ProcessoSelecionadoId"
                                                    @state="atualizarEstadoWorkflow" />

                            <div class="form-grid form-grid-2">
                                <div class="form-group">
                                    <label class="form-label">Nome do Processo</label>
                                    <input type="text" class="form-control"
                                           v-model="dsNomeProcesso"
                                           :class="{ 'border-danger': camposInvalidos.dsNomeProcesso }"
                                           maxlength="200" />
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Lote Único</label>
                                    <select class="form-control"
                                            v-model="flLoteUnico"
                                            :class="{ 'border-danger': camposInvalidos.flLoteUnico }">
                                        <option disabled value="">Selecione:</option>
                                        <option :value="true">Sim</option>
                                        <option :value="false">Não</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label">Descrição do Processo</label>
                                <textarea class="form-control form-textarea"
                                          v-model="dsProcesso"
                                          maxlength="500"
                                          rows="3"></textarea>
                                <small class="text-muted">Máximo de 500 caracteres.</small>
                            </div>

                            <div v-if="hasMatchingWorkflow" class="form-grid form-grid-2">
                                <div>
                                    <label class="form-label">Data de início</label>
                                    <input type="date" class="form-control"
                                           v-model="dtInicio"
                                           :class="{ 'border-danger': camposInvalidos.dtInicio }" />

                                    <div class="form-grid form-group-inline mt-2">

                                        <div class="info-chip w-100">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .876-.252 1.02-.598l.088-.416c.066-.3.104-.378.288-.41l.451-.083.082-.38-1.428-.287.545-2.545z" />
                                                <circle cx="8" cy="4.5" r="1" />
                                            </svg>
                                            Os prazos definidos no fluxo serão contabilizados a partir desta data.
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <label class="form-label">Data estimada de finalização</label>
                                    <input type="date" class="form-control"
                                           v-model="dtFinalizacaoEstimada" />
                                </div>
                            </div>
                        </div>

                        <!-- ===================== ABA SOLICITAÇÃO + ITENS ===================== -->
                        <div v-show="activeTab === 'solicitacao'">



                            <!-- Cards lado a lado: Setores + Inclusão de itens -->
                            <div class="cards-row-horizontal mb-3">
                                <!-- Card Setores -->
                                <div class="section-card card-setor">
                                    <div class="form-group form-group-setores">
                                        <label class="form-label">Setores Requisitados</label>
                                        <div class="setores-select-wrap">
                                            <v-select v-model="setoresResponsaveis"
                                                      :options="setores"
                                                      :clearable="true"
                                                      :multiple="true"
                                                      :closeOnSelect="false"
                                                      :loading="buscandoSetores"
                                                      placeholder="Selecione um ou mais setores"
                                                      :get-option-label="getLabelSetor">
                                                <template #no-options>
                                                    <span>Não há setores disponíveis.</span>
                                                </template>
                                            </v-select>
                                        </div>
                                        <small v-if="camposInvalidosSolicitacao.setores" class="text-danger">
                                            Selecione ao menos 1 setor.
                                        </small>

                                        <div class="form-group">
                                            <label class="form-label">Prazo</label>
                                            <input type="date"
                                                   class="form-control"
                                                   v-model="dtPrazoCriacaoRegistro"
                                                   :min="todayISO"
                                                   :class="{ 'border-danger': camposInvalidosSolicitacao.prazo }" />
                                        </div>
                                    </div>
                                    <small class="text-muted">Os setores selecionados receberão a solicitação para criação do Registro de Necessidade.</small>
                                </div>

                                <!-- Card Adicionar item -->
                                <div class="section-card card-itens">
                                    <div class="form-group">
                                        <label class="form-label">Item do catálogo</label>
                                        <v-select v-model="itemCatalogoSelecionado"
                                                  :options="listaItensCatalogo"
                                                  :filterable="false"
                                                  :clearable="true"
                                                  :loading="buscandoCatalogo"
                                                  @search="onSearchCatalogo"
                                                  :get-option-label="getLabelCatalogo"
                                                  placeholder="Digite ao menos 3 caracteres...">
                                            <template #no-options>
                                                <span>Digite ao menos 3 caracteres.</span>
                                            </template>
                                        </v-select>
                                        <small v-if="camposInvalidosItemAdd.item" class="text-danger">Selecione um item válido.</small>
                                        <small v-if="mensagemDuplicado" class="text-warning">Esse item já foi adicionado.</small>
                                    </div>

                                    <div class="form-row-add-item">
                                        <div class="form-group form-group-flex">
                                            <label class="form-label">Unid. Medida</label>
                                            <select class="form-control"
                                                    v-model.number="unidadeSelecionadaId"
                                                    :class="{ 'border-danger': camposInvalidosItemAdd.unidade }">
                                                <option disabled value="">Selecione</option>
                                                <option v-for="um in (unidadesMedida || [])"
                                                        :key="um.idUnidadeMedida"
                                                        :value="um.idUnidadeMedida">
                                                    {{ formatarUnidade(um) }}
                                                </option>
                                            </select>
                                            <small v-if="camposInvalidosItemAdd.unidade" class="text-danger">Selecione a unidade.</small>
                                        </div>

                                        <div class="form-group form-group-flex" v-if="flLoteUnico === false">
                                            <label class="form-label">Lote</label>
                                            <select class="form-control" v-model.number="loteSelecionado">
                                                <option v-for="l in lotes" :key="l" :value="l">Lote {{ l }}</option>
                                            </select>
                                        </div>

                                        <div class="form-group form-group-add-btn">
                                            <label class="form-label">&nbsp;</label>
                                            <button class="modern-btn modern-btn-primary btn-add-fixed"
                                                    type="button"
                                                    :disabled="!podeAdicionar"
                                                    @click="adicionarItem">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                                </svg>
                                                Adicionar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- toolbar lotes (quando não é lote único) -->
                            <div class="custom-table-header" v-if="flLoteUnico === false">
                                <div class="right-tools w-100" style="justify-content:flex-end;">
                                    <div class="totals" style="align-items:center; gap:10px;">
                                        <span class="total-chip">Lote atual:</span>

                                        <button v-for="l in lotes"
                                                :key="l"
                                                type="button"
                                                class="total-chip"
                                                :class="{ 'chip-active': activeLote === l }"
                                                @click="setActiveLote(l)">
                                            Lote {{ l }} <b v-if="countItensInLote(l)">({{ countItensInLote(l) }})</b>
                                        </button>

                                        <button class="modern-btn modern-btn-secondary" type="button" @click="addLote">+ Lote</button>
                                        <button class="modern-btn modern-btn-danger" type="button" @click="removeLote">- Lote</button>
                                    </div>
                                </div>
                            </div>
                            <!-- lista -->
                            <div class="table-wrapper modern-table" v-if="itens.length">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="white-space:nowrap;width:1%;">Item</th>
                                            <th>Nome</th>
                                            <th v-if="flLoteUnico === false" class="text-center" style="white-space:nowrap;width:8%;">Lote</th>
                                            <th class="text-center" style="white-space:nowrap;width:8%;">UM</th>
                                            <th class="text-center" style="white-space:nowrap;width:1%;">Ações</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(n, idx) in itens.filter(x=>x.lote == loteSelecionado)" :key="n.idKey">
                                            <td class="text-center">
                                                <span class="id-badge">{{ n.cdItem }}</span>
                                            </td>

                                            <td>
                                                <div class="item-name">{{ n.nmItem }}</div>
                                                <div class="item-details">
                                                    {{ n.cdReferencia || '-' }}
                                                    <span v-if="n.tpItem"> • {{ n.tpItem }}</span>
                                                </div>
                                            </td>

                                            <td v-if="flLoteUnico === false" class="text-center">
                                                
                                                <span>Lote {{n.lote}}</span>
                                            </td>

                                            <td class="text-center">
                                                <select class="form-control form-control-sm" v-model.number="n.idUnidadeMedida">
                                                    <option disabled value="">Selecione</option>
                                                    <option v-for="um in (unidadesMedida || [])"
                                                            :key="um.idUnidadeMedida"
                                                            :value="um.idUnidadeMedida">
                                                        {{ formatarUnidade(um) }}
                                                    </option>
                                                </select>
                                            </td>

                                            <td class="text-center">
                                                <button class="action-btn action-btn-delete"
                                                        type="button"
                                                        :disabled="loading"
                                                        @click="removerItem(idx)"
                                                        title="Remover item">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1z" />
                                                    </svg>
                                                    <span class="action-text">Remover</span>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div v-else class="empty-state">
                                <div class="empty-content">
                                    <h3 class="empty-title">Nenhum item adicionado</h3>
                                    <p class="empty-description">Pesquise no catálogo e adicione itens com unidade de medida.</p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="modal-modern-footer">
                        <!-- ETAPA 1: Processo -->
                        <template v-if="activeTab === 'processo'">
                            <div class="d-flex gap-2">
                                <button type="button"
                                        class="modern-btn modern-btn-secondary flex-fill"
                                        :disabled="loading"
                                        data-bs-dismiss="modal">
                                    Cancelar
                                </button>

                                <button type="button"
                                        class="modern-btn modern-btn-primary flex-fill"
                                        :disabled="loading"
                                        @click="irParaSolicitacao">
                                    Próximo
                                </button>
                            </div>
                        </template>

                        <!-- ETAPA 2: Solicitação + Itens -->
                        <template v-else>
                            <div class="d-flex gap-2">
                                <button type="button"
                                        class="modern-btn modern-btn-light flex-fill"
                                        :disabled="loading"
                                        @click="activeTab = 'processo'">
                                    Voltar
                                </button>

                                <button type="button"
                                        class="btn btn-primary btn-modern-primary flex-fill"
                                        :disabled="loading"
                                        @click="salvar">
                                    Salvar Tudo
                                </button>
                            </div>
                        </template>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import SelectWorkflowProcesso from '@/components/ProcessoInteligente/SelectWorkflowProcesso.vue'

    export default {
        name: 'ModalCriarProcessoERegistro',
        components: { 'v-select': vSelect, SelectWorkflowProcesso },

        props: {
            legislacoes: { type: Array, default: () => [] },
            tiposProcessos: { type: Array, default: () => [] },
        },

        data() {
            return {
                bsModal: null,
                onHidden: null,

                activeTab: 'processo',
                loading: false,

                // ===== Processo
                legislacaoSelecionadaId: '',
                ProcessoSelecionadoId: '',
                flLoteUnico: '',
                dsNomeProcesso: '',
                cdProcessoNumero: '',
                dsProcesso: '',
                dtInicio: '',
                dtFinalizacaoEstimada: '',
                idProcessoWorkflowSelecionado: null,
                workflowCarregando: false,
                possuiWorkflows: false,

                camposInvalidos: {
                    dsNomeProcesso: false,
                    legislacaoSelecionadaId: false,
                    flLoteUnico: false,
                    ProcessoSelecionadoId: false,
                    cdProcessoNumero: false,
                    dtInicio: false,
                },

                // ===== Solicitação (setores responsáveis)
                setoresResponsaveis: [], // <-- agora é array
                setores: [],
                buscandoSetores: false,
                dtPrazoCriacaoRegistro: '',
                camposInvalidosSolicitacao: {
                    setores: false,
                    prazo: false,
                },

                // ===== Itens
                unidadesMedida: [],

                itemCatalogoSelecionado: null,
                listaItensCatalogo: [],
                buscandoCatalogo: false,
                catalogoDebounce: null,

                loteSelecionado: 1,
                unidadeSelecionadaId: '',

                camposInvalidosItemAdd: {
                    item: false,
                    unidade: false,
                },

                mensagemDuplicado: false,

                itens: [], // [{ idKey, idItem, cdItem, cdReferencia, nmItem, tpItem, lote, idUnidadeMedida }]
                lotes: [1],
                activeLote: 1,
            }
        },

        computed: {
            hasMatchingWorkflow() {
                return this.possuiWorkflows
            },
            todayISO() {
                const d = new Date()
                const y = d.getFullYear()
                const m = String(d.getMonth() + 1).padStart(2, '0')
                const day = String(d.getDate()).padStart(2, '0')
                return `${y}-${m}-${day}`
            },
            processoOk() {
                const nomeOk = !!this.dsNomeProcesso?.trim()
                const legOk = !!this.legislacaoSelecionadaId
                const tipoOk = !!this.ProcessoSelecionadoId
                const numeroOk = !!this.cdProcessoNumero?.trim()
                const loteOk = this.flLoteUnico === true || this.flLoteUnico === false
                const dtOk = !this.hasMatchingWorkflow || !!this.dtInicio
                return nomeOk && legOk && tipoOk && numeroOk && loteOk && dtOk
            },

            podeAdicionar() {
                if (!this.itemCatalogoSelecionado) return false

                const id = this.getIdItem(this.itemCatalogoSelecionado)
                if (!id) return false

                if (!this.unidadeSelecionadaId) return false

                return !this.jaExiste(id, this.loteSelecionado)
            },
        },

        watch: {
            legislacaoSelecionadaId() {
                this.handleWorkflowToggle()
            },

            ProcessoSelecionadoId() {
                this.handleWorkflowToggle()
            },

            flLoteUnico(newVal) {
                if (newVal === true) {
                    this.lotes = [1]
                    this.activeLote = 1
                    this.loteSelecionado = 1
                    this.itens.forEach(it => (it.lote = 1))
                }
                if (newVal === false) {
                    if (!this.lotes?.length) this.lotes = [1]
                    if (!this.activeLote || !this.lotes.includes(this.activeLote)) this.activeLote = this.lotes[0] || 1
                    this.loteSelecionado = this.activeLote
                }
            },

            itemCatalogoSelecionado() {
                this.mensagemDuplicado = false
                this.camposInvalidosItemAdd.item = false
            },

            unidadeSelecionadaId() {
                this.camposInvalidosItemAdd.unidade = false
            },

            dtPrazoCriacaoRegistro() {
                this.camposInvalidosSolicitacao.prazo = false
            },

            setoresResponsaveis() {
                this.camposInvalidosSolicitacao.setores = false
            },
        },

        mounted() {
            const el = document.getElementById('ModalCriarProcessoERegistro')
            const bs = window.bootstrap || window.Bootstrap
            if (el && bs?.Modal) this.bsModal = new bs.Modal(el, { focus: false })

            this.onHidden = () => this.onModalHidden()
            if (el) el.addEventListener('hidden.bs.modal', this.onHidden)
        },

        beforeDestroy() {
            const el = document.getElementById('ModalCriarProcessoERegistro')
            if (el && this.onHidden) el.removeEventListener('hidden.bs.modal', this.onHidden)
        },

        methods: {
            abrir() {
                this.reset()

                Promise.all([
                    this.getUsuarioConfiguracao(),
                    this.getUnidadesMedida(),
                ]).then(() => {
                    this.bsModal?.show?.()
                })
            },

            onModalHidden() {
                this.reset()
            },

            reset() {
                this.activeTab = 'processo'
                this.loading = false

                // processo
                this.legislacaoSelecionadaId = ''
                this.ProcessoSelecionadoId = ''
                this.flLoteUnico = ''
                this.dsNomeProcesso = ''
                this.cdProcessoNumero = ''
                this.dsProcesso = ''
                this.dtInicio = ''
                this.dtFinalizacaoEstimada = ''
                this.idProcessoWorkflowSelecionado = null
                this.workflowCarregando = false
                this.possuiWorkflows = false

                Object.keys(this.camposInvalidos).forEach(k => (this.camposInvalidos[k] = false))

                // solicitação
                this.setoresResponsaveis = []
                this.dtPrazoCriacaoRegistro = ''
                this.camposInvalidosSolicitacao = { setores: false, prazo: false }

                // itens
                this.itemCatalogoSelecionado = null
                this.listaItensCatalogo = []
                this.buscandoCatalogo = false
                clearTimeout(this.catalogoDebounce)
                this.catalogoDebounce = null

                this.loteSelecionado = 1
                this.unidadeSelecionadaId = ''

                this.camposInvalidosItemAdd = { item: false, unidade: false }
                this.mensagemDuplicado = false

                this.itens = []
                this.lotes = [1]
                this.activeLote = 1
            },

            handleWorkflowToggle() {
                if (!this.hasMatchingWorkflow) {
                    this.dtInicio = ''
                    this.camposInvalidos.dtInicio = false
                }
            },

            atualizarEstadoWorkflow(estado) {
                this.workflowCarregando = estado.loading === true
                this.possuiWorkflows = estado.hasWorkflows === true
                this.handleWorkflowToggle()
            },

            // ===== carregamentos
            async getUsuarioConfiguracao() {
                this.buscandoSetores = true
                try {
                    const res = await axios.get(`${urlApi}/UsuarioSetor/GetUsuarioConfiguracao`)
                    if (res.data?.success) {
                        const arr = Array.isArray(res.data?.data?.setores) ? res.data.data.setores : []
                        this.setores = arr
                    } else {
                        this.setores = []
                    }
                } catch (e) {
                    this.setores = []
                    avisoToast('Erro ao carregar setores!', 'warning')
                } finally {
                    this.buscandoSetores = false
                }
            },

            async getUnidadesMedida() {
                try {
                    const res = await axios.get(`${urlApi}/CadastroItem/GetUnidadesMedida`)
                    this.unidadesMedida = res.data?.success ? (res.data.data || []) : (res.data?.data || [])
                } catch (e) {
                    this.unidadesMedida = []
                    avisoErro(e.response?.data || e.message || 'Erro ao carregar unidades de medida!')
                }
            },

            // ===== catálogo (v-select com search)
            onSearchCatalogo(search) {
                const termo = (search || '').trim()
                if (termo.length < 3) {
                    this.listaItensCatalogo = []
                    return
                }

                clearTimeout(this.catalogoDebounce)
                this.catalogoDebounce = setTimeout(async () => {
                    this.buscandoCatalogo = true
                    try {
                        const params = { take: 20, index: 0, dsTermo: termo }
                        const res = await axios.get(`${urlApi}/CadastroItem/Get`, { params })
                        if (res.data?.success) {
                            const rows = res.data.data?.rows || []
                            this.listaItensCatalogo = rows
                                .map(r => r.item || r.cadastroItem || r)
                                .filter(o => o && (o.idItem || o.cdItem || o.nmItem))
                        } else {
                            this.listaItensCatalogo = []
                        }
                    } catch (e) {
                        this.listaItensCatalogo = []
                    } finally {
                        this.buscandoCatalogo = false
                    }
                }, 300)
            },

            getLabelCatalogo(opt) {
                const o = opt || {}
                return `${o.cdReferencia || o.cdItem || ''} - ${o.nmItem || ''}`.trim()
            },

            getIdItem(opt) {
                return opt?.idItem || null
            },

            getLabelSetor(option) {
                return option?.nmSetor || ''
            },

            // ===== lotes
            setActiveLote(l) {
                if (this.flLoteUnico === true) return
                const n = Number(l) || 1
                this.activeLote = n
                this.loteSelecionado = n
            },

            addLote() {
                const max = Math.max(...(this.lotes || [1]))
                const next = (Number.isFinite(max) ? max : 1) + 1
                this.lotes = [...this.lotes, next]
                this.activeLote = next
                this.loteSelecionado = next
            },

            removeLote() {
                if (this.lotes.length <= 1) return

                let loteRemover = this.activeLote;
                this.lotes = this.lotes.filter(x => x != loteRemover)

                this.itens = this.itens.filter(x => x.lote != loteRemover)
            },

            countItensInLote(l) {
                const lote = Number(l) || 1
                return this.itens.filter(x => Number(x.lote) === lote).length
            },

            // ===== itens (lista)
            jaExiste(idItem,lote) {
                return this.itens.some(n => n.idItem === idItem && n.lote === lote)
            },

            adicionarItem() {
                this.mensagemDuplicado = false

                this.camposInvalidosItemAdd.item = !this.itemCatalogoSelecionado
                this.camposInvalidosItemAdd.unidade = !this.unidadeSelecionadaId

                if (Object.values(this.camposInvalidosItemAdd).some(Boolean)) {
                    avisoToast('Selecione o item e a unidade de medida.', 'warning')
                    return
                }

                const idItem = this.getIdItem(this.itemCatalogoSelecionado)
                if (!idItem) {
                    avisoErro('Item inválido (sem idItem).')
                    return
                }

                if (this.jaExiste(idItem, this.loteSelecionado)) {
                    this.mensagemDuplicado = true
                    avisoToast('Esse item já foi adicionado.', 'warning')
                    return
                }

                const o = this.itemCatalogoSelecionado
                const lote = (this.flLoteUnico === true) ? 1 : (Number(this.loteSelecionado) || this.activeLote || 1)

                this.itens.push({
                    idKey: `${idItem}-${Date.now()}`,
                    idItem,
                    cdItem: o.cdItem || null,
                    cdReferencia: o.cdReferencia || null,
                    nmItem: o.nmItem || '',
                    tpItem: o.tpItem || null,
                    lote,
                    idUnidadeMedida: Number(this.unidadeSelecionadaId) || '',
                })

                // limpar campos add
                this.itemCatalogoSelecionado = null
                this.listaItensCatalogo = []
                this.unidadeSelecionadaId = ''
                this.camposInvalidosItemAdd = { item: false, unidade: false }
            },

            removerItem(idx) {
                this.itens.splice(idx, 1)
            },

            // ===== validações
            validarProcesso() {
                if (this.workflowCarregando) {
                    avisoToast('Aguarde o carregamento dos workflows.', 'warning')
                    return false
                }
                this.camposInvalidos.dsNomeProcesso = !this.dsNomeProcesso?.trim()
                this.camposInvalidos.legislacaoSelecionadaId = !this.legislacaoSelecionadaId
                this.camposInvalidos.ProcessoSelecionadoId = !this.ProcessoSelecionadoId
                this.camposInvalidos.cdProcessoNumero = !this.cdProcessoNumero?.trim()
                this.camposInvalidos.flLoteUnico = this.flLoteUnico !== true && this.flLoteUnico !== false
                this.camposInvalidos.dtInicio = this.hasMatchingWorkflow && !this.dtInicio
                const workflowInvalido = this.possuiWorkflows && !this.idProcessoWorkflowSelecionado

                const invalido = Object.values(this.camposInvalidos).some(Boolean) || workflowInvalido
                if (invalido) {
                    avisoToast('Preencha todos os campos obrigatórios do processo.', 'warning')
                    return false
                }
                return true
            },

            validarSolicitacaoEItens() {
                this.camposInvalidosSolicitacao.setores = !(this.setoresResponsaveis && this.setoresResponsaveis.length > 0)

                const prazo = (this.dtPrazoCriacaoRegistro || '').trim()
                const prazoOk = !!prazo && prazo >= this.todayISO
                this.camposInvalidosSolicitacao.prazo = !prazoOk

                if (this.camposInvalidosSolicitacao.setores || this.camposInvalidosSolicitacao.prazo) {
                    avisoToast('Selecione ao menos 1 setor e informe o prazo de criação do Registro de Necessidade.', 'warning')
                    return false
                }

                if (!this.itens.length) {
                    avisoToast('Adicione ao menos 1 item.', 'warning')
                    return false
                }

                const ok = this.itens.every(it => {
                    const idItem = Number(it.idItem || 0)
                    const un = Number(it.idUnidadeMedida || 0)
                    const loteOk = this.flLoteUnico === true ? true : (Number(it.lote || 0) > 0)
                    return idItem > 0 && un > 0 && loteOk
                })

                if (!ok) {
                    avisoToast('Verifique: cada item precisa de UM (e lote, se aplicável).', 'warning')
                    return false
                }

                return true
            },

            irParaSolicitacao() {
                if (!this.validarProcesso()) {
                    this.activeTab = 'processo'
                    return
                }
                this.activeTab = 'solicitacao'
            },

            // ===== salvar
            async salvar() {
                if (!this.validarProcesso()) {
                    this.activeTab = 'processo'
                    return
                }
                if (!this.validarSolicitacaoEItens()) {
                    this.activeTab = 'solicitacao'
                    return
                }

                const idsSetores = (this.setoresResponsaveis || [])
                    .map(s => Number(s?.idSetor || 0))
                    .filter(n => n > 0)

                const payload = {
                    processo: {
                        idLegislacao: Number(this.legislacaoSelecionadaId),
                        idTipoProcesso: Number(this.ProcessoSelecionadoId),
                        idProcessoWorkflow: this.idProcessoWorkflowSelecionado,
                        flLoteUnico: this.flLoteUnico,
                        dsNome: this.dsNomeProcesso,
                        dsProcesso: this.dsProcesso,
                        cdProcesso: this.cdProcessoNumero,
                        dtInicio: this.hasMatchingWorkflow ? this.dtInicio : null,
                        dtFinalizacaoEstimada: this.dtFinalizacaoEstimada || null,
                    },

                    // ⚠️ AJUSTE AQUI se o seu backend não aceitar idsSetores:
                    // Exemplo alternativo: solicitacoes: idsSetores.map(id => ({ idSetor: id, dtLimite: this.dtPrazoCriacaoRegistro || null }))
                    solicitacao: {
                        idsSetores, // <-- agora múltiplos
                        dtLimite: this.dtPrazoCriacaoRegistro || null,
                    },

                    itens: this.itens.map(it => ({
                        idItem: Number(it.idItem),
                        lote: this.flLoteUnico === true ? 1 : (Number(it.lote) || 1),
                        idUnidadeMedida: Number(it.idUnidadeMedida) || 0,
                    })),
                }

                this.loading = true
                try {
                    const res = await axios.post(`${urlApi}/RegistroNecessidade/PostProcessoESolicitacao`, payload)
                    console.log(res)
                    if (!res.data?.success) {
                        avisoErro(res.data?.msg || 'Erro ao salvar!')
                        return
                    }

                    avisoToast('Processo + solicitação criados com sucesso!', 'success')
                    this.bsModal?.hide?.()
                    this.$emit('saved', res.data?.data || null)
                } catch (err) {
                    const apiData = err.response?.data
                    const msgBase =
                        apiData?.msg ||
                        apiData?.title || // caso venha ProblemDetails do ASP.NET
                        err.message ||
                        'Erro ao salvar!'
                    let detalhes = ''
                    if (Array.isArray(apiData?.errors)) {
                        detalhes = apiData.errors.join(' ')
                    } else if (apiData?.errors && typeof apiData.errors === 'object') {
                        // validação de model state (errors como objeto)
                        detalhes = Object.values(apiData.errors).flat().join(' ')
                    }
                    avisoErro([msgBase, detalhes].filter(Boolean).join(' - '))
                } finally {
                    this.loading = false
                }
            },

            // ===== helpers
            formatarUnidade(um) {
                return `${um.cdUnidadeMedida}`
            },
        }
    }
</script>


<style scoped>
    .modal-grande {
        width: 100% !important;
        max-width: calc(100vw - 40px) !important;
        margin: auto;
        margin-top: 20px;
        padding: 0 12px;
    }

    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 20px;
        position: relative;
        z-index: 1;
    }

        .modal-modern-header::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

        .modal-modern-header .header-icon {
            width: 64px;
            height: 64px;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
            color: #2563eb;
            flex-shrink: 0;
        }

        .modal-modern-header .header-text {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 6px;
        }

            .modal-modern-header .header-text h2 {
                margin: 0;
                font-size: 24px;
                font-weight: 700;
                color: #0f172a;
            }

            .modal-modern-header .header-text p {
                margin-top: 6px;
                margin-bottom: 0;
                color: #475569;
                font-size: 14px;
                max-width: 420px;
                line-height: 1.4;
            }

    .header-status {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .tabs-row {
        display: flex;
        gap: 8px;
        background: rgba(248, 250, 252, 0.9);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 12px;
        padding: 4px;
    }

    .tab-btn {
        padding: 10px 20px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.2s ease;
        background: transparent;
        color: #64748b;
    }

        .tab-btn:hover {
            background: rgba(59, 130, 246, 0.1);
            color: #2563eb;
        }

        .tab-btn.active {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: #ffffff;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }

        .tab-btn.blocked {
            opacity: 0.5;
            cursor: not-allowed;
            position: relative;
        }

            .tab-btn.blocked:hover {
                background: transparent;
                color: #64748b;
            }

    .modal-modern-body {
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-3 {
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .form-group-inline {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
    }

        .form-group-inline .info-chip {
            display: inline-flex;
            align-items: flex-start;
            gap: 8px;
            padding: 12px 16px;
            border-radius: 12px;
            background: rgba(37, 99, 235, 0.08);
            color: #1e3a8a;
            font-size: 13px;
            line-height: 1.4;
            max-width: 380px;
        }

    .form-textarea {
        min-height: 110px;
        resize: vertical;
    }

    .modern-modal .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background: #ffffff;
        padding: 12px 16px;
        font-size: 14px;
        color: #1f2937;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

        .modern-modal .form-control:focus {
            border-color: rgba(37, 99, 235, 0.6);
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
            background-color: #ffffff;
        }

    .modern-modal select.form-control {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: #ffffff;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

    .modern-modal .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        margin-bottom: 2px;
        margin-top: 12px;
    }

    .modern-modal small.text-muted {
        color: #64748b;
    }

    /* V-Select – alinhado ao estilo moderno do modal */
    :deep(.v-select) {
        position: relative;
    }

    :deep(.v-select .vs__dropdown-toggle) {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background: #ffffff;
        padding: 10px 14px;
        height: 48px;
        transition: all 0.2s ease;
    }

    :deep(.v-select .vs__dropdown-toggle:hover) {
        border-color: rgba(59, 130, 246, 0.4);
    }

    :deep(.v-select.vs--open .vs__dropdown-toggle) {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
    }

    :deep(.v-select .vs__search) {
        font-size: 14px;
        color: #1f2937;
        padding: 0;
        margin: 0;
        border: none;
        outline: none;
        min-height: 28px;
    }

    :deep(.v-select .vs__search::placeholder) {
        color: #94a3b8;
        font-size: 14px;
    }

    :deep(.v-select .vs__selected) {
        color: #1f2937;
        font-size: 14px;
        margin: 0;
        padding: 0;
    }

    :deep(.v-select .vs__actions) {
        padding: 0 4px;
    }

    :deep(.v-select .vs__clear) {
        fill: #64748b;
    }

    :deep(.v-select .vs__clear:hover) {
        fill: #dc2626;
    }

    :deep(.v-select .vs__open-indicator) {
        fill: #64748b;
        transition: transform 0.2s ease;
    }

    :deep(.v-select.vs--open .vs__open-indicator) {
        transform: rotate(180deg);
        fill: #2563eb;
    }

    :deep(.v-select .vs__dropdown-menu) {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.15);
        margin-top: 6px;
        background: #ffffff;
        max-height: 300px;
        overflow-y: auto;
        padding: 8px 0;
        z-index: 1060 !important;
    }

    :deep(.v-select .vs__dropdown-option) {
        padding: 12px 18px;
        color: #1f2937;
        font-size: 14px;
        transition: all 0.2s ease;
        cursor: pointer;
    }

    :deep(.v-select .vs__dropdown-option:hover) {
        background: rgba(59, 130, 246, 0.1);
        color: #2563eb;
    }

    :deep(.v-select .vs__dropdown-option--highlight) {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.15) 0%, rgba(59, 130, 246, 0.1) 100%);
        color: #1d4ed8;
        font-weight: 600;
    }

    :deep(.v-select .vs__spinner) {
        border-color: #2563eb transparent transparent transparent;
    }

    .form-control-sm {
        padding: 8px 12px;
        font-size: 13px;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }

    .form-grid-3 {
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }

    .form-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        justify-content: flex-end;
        margin-top: 8px;
    }


    .custom-table-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        flex-wrap: wrap;
        margin-bottom: 16px;
    }

    .left-tools {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .right-tools {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .search-box {
        position: relative;
        flex: 1;
        min-width: 200px;
    }

    .modern-search-input {
        width: 100%;
        padding: 10px 14px;
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        font-size: 14px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        background: #ffffff;
        color: #1f2937;
    }

        .modern-search-input:focus {
            border-color: rgba(37, 99, 235, 0.6);
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
            outline: none;
        }

    .totals {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
    }

    .total-chip {
        padding: 8px 14px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 2px solid #bfdbfe;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        color: #1e40af;
        cursor: pointer;
        transition: all 0.2s ease;
        border: 2px solid #bfdbfe;
    }

        .total-chip:hover {
            background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
        }

        .total-chip.chip-active {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            border-color: #1e40af;
            color: #ffffff;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }

            .total-chip.chip-active:hover {
                background: linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%);
            }

    .table-wrapper {
        margin-top: 4px;
    }

    .modern-table .custom-table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid rgba(148, 163, 184, 0.2);
    }

        .modern-table .custom-table thead {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .modern-table .custom-table th,
        .modern-table .custom-table td {
            padding: 14px 18px;
            border-bottom: 1px solid rgba(148, 163, 184, 0.16);
            font-size: 14px;
            color: #1e293b;
        }

        .modern-table .custom-table th {
            font-weight: 700;
            text-transform: uppercase;
            font-size: 12px;
            letter-spacing: 0.45px;
        }

        .modern-table .custom-table tbody tr:hover {
            background: rgba(59, 130, 246, 0.08);
        }

    .id-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 10px;
        font-weight: 700;
        font-size: 13px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 1px solid rgba(59, 130, 246, 0.3);
        color: #1d4ed8;
    }

    .item-name {
        font-weight: 600;
        color: #0f172a;
        font-size: 14px;
        margin-bottom: 4px;
    }

    .item-details {
        font-size: 13px;
        color: #64748b;
    }

    .number-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 10px;
        font-weight: 700;
        font-size: 13px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 1px solid rgba(59, 130, 246, 0.3);
        color: #1d4ed8;
    }

    .pill {
        display: inline-flex;
        align-items: center;
        padding: 4px 12px;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 600;
        border: 1px solid transparent;
    }

    .pill-ok {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
        border-color: rgba(16, 185, 129, 0.25);
    }

    .pill-off {
        background: rgba(239, 68, 68, 0.12);
        color: #dc2626;
        border-color: rgba(239, 68, 68, 0.25);
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 13px;
        border: 2px solid transparent;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        background: #f8fafc;
        color: #1f2937;
    }

        .action-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
        }

    .action-btn-view {
        background: rgba(59, 130, 246, 0.12);
        color: #2563eb;
        border-color: rgba(59, 130, 246, 0.35);
    }

        .action-btn-view:hover {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: #ffffff;
            border-color: transparent;
        }

    .action-btn-delete {
        background: rgba(239, 68, 68, 0.12);
        color: #dc2626;
        border-color: rgba(239, 68, 68, 0.35);
    }

        .action-btn-delete:hover {
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
            color: #ffffff;
            border-color: transparent;
        }

    .section-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.95) 100%);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 18px;
        padding: 20px 22px;
        box-shadow: 0 12px 28px rgba(148, 163, 184, 0.15);
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    /* Cards lado a lado (horizontal) */
    .cards-row-horizontal {
        display: flex;
        flex-direction: row;
        gap: 20px;
        align-items: stretch;
    }

        .cards-row-horizontal .card-setor {
            flex: 0 0 420px;
            min-width: 420px;
        }

        .cards-row-horizontal .card-itens {
            flex: 1;
            min-width: 0;
        }

    /* Card Setores: disposição e visual dos setores selecionados (chips) */
    .card-setor .setores-select-wrap {
        width: 100%;
    }

    .card-setor .setores-select-wrap :deep(.v-select.vs--multiple .vs__dropdown-toggle) {
        min-height: 52px;
        height: auto !important;
        padding: 12px 14px !important;
        align-items: flex-start;
    }

    .card-setor .setores-select-wrap :deep(.v-select .vs__selected-options) {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        align-items: center;
        padding: 0 4px 0 0;
        min-height: 28px;
    }

    /* Cada setor selecionado = chip (span.vs__selected) */
    .card-setor .setores-select-wrap :deep(.v-select .vs__selected) {
        display: inline-flex !important;
        align-items: center;
        margin: 0 !important;
        padding: 8px 14px !important;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%) !important;
        border: 1px solid rgba(59, 130, 246, 0.4) !important;
        border-radius: 12px !important;
        font-size: 13px !important;
        font-weight: 600 !important;
        color: #1d4ed8 !important;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.12);
        flex-shrink: 0;
    }

    .card-setor .setores-select-wrap :deep(.v-select .vs__deselect) {
        margin-left: 6px;
        padding: 2px;
        border-radius: 6px;
        transition: background 0.2s, fill 0.2s;
    }

    .card-setor .setores-select-wrap :deep(.v-select .vs__deselect:hover) {
        background: rgba(239, 68, 68, 0.15);
        fill: #dc2626;
    }

    .card-setor .setores-select-wrap :deep(.v-select .vs__search) {
        flex: 1 1 140px;
        min-width: 120px;
        margin: 0;
    }

    /* Linha 2: campos flexíveis + botão fixo */
    .form-row-add-item {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: flex-end;
    }

    .form-group-flex {
        flex: 1 1 120px;
        min-width: 100px;
    }

    .form-group-add-btn {
        flex: 0 0 auto;
    }

    .btn-add-fixed {
        min-width: 130px;
        white-space: nowrap;
    }

    .details-card {
        padding: 12px;
        border-radius: 10px;
    }

    .dependency-toolbar {
        background: rgba(248, 250, 252, 0.9);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 16px;
        padding: 16px 18px;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
    }

    .toolbar-text {
        color: #475569;
        font-size: 13px;
        max-width: 460px;
        line-height: 1.5;
    }

    .toolbar-actions {
        display: flex;
        align-items: center;
        gap: 14px;
        flex-wrap: wrap;
    }

    .empty-state {
        padding: 32px 24px;
        text-align: center;
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-icon {
        color: #94a3b8;
    }

    .empty-title {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #0f172a;
    }

    .empty-description {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .btn-close-modern {
        position: absolute;
        top: 18px;
        right: 18px;
        width: 44px;
        height: 44px;
        border-radius: 50% !important;
        background: #ffffff !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

        .btn-close-modern svg {
            color: #334155;
        }

        .btn-close-modern:hover {
            transform: scale(1.07);
            box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
            border-color: transparent !important;
        }

            .btn-close-modern:hover svg {
                color: #ffffff;
            }

        .btn-close-modern:disabled {
            opacity: 0.7;
            cursor: not-allowed;
        }

    .btn-md {
        z-index: 1001;
    }

    .btn-modern-primary {
        border: none;
        border-radius: 12px;
        padding: 14px 20px;
        font-weight: 700;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

        .btn-modern-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 16px 32px rgba(37, 99, 235, 0.4);
        }

        .btn-modern-primary:active {
            transform: translateY(0);
        }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 22px;
        border-radius: 14px;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        box-shadow: 0 8px 22px rgba(15, 23, 42, 0.12);
        color: #ffffff;
    }

        .modern-btn:hover {
            transform: translateY(-2px);
        }

        .modern-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none;
        }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    }

    .modern-btn-secondary {
        background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
    }
    .modern-btn-danger {
        background: linear-gradient(135deg, #f87171 0%, #ef4444 100%);
        color: #ffffff;
    }

    .modern-btn-light {
        background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
        color: #475569;
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
    }

        .modern-btn-light:hover {
            background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
        }

    .spinner-border-sm {
        width: 1rem;
        height: 1rem;
        border-width: 0.15em;
    }

    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

            .modal-modern-header::after {
                left: 20px;
                right: 20px;
            }

            .modal-modern-header .header-icon {
                width: 56px;
                height: 56px;
            }

        .header-status {
            width: 100%;
        }

        .tabs-row {
            width: 100%;
        }

        .tab-btn {
            flex: 1;
        }

        .form-group-inline {
            flex-direction: column;
            align-items: stretch;
        }

        .form-grid-2,
        .form-grid-3 {
            grid-template-columns: 1fr;
        }

        .cards-row-horizontal {
            flex-direction: column;
        }

            .cards-row-horizontal .card-setor {
                flex: 1 1 auto;
                min-width: 0;
            }

        .form-row-add-item {
            flex-direction: column;
            align-items: stretch;
        }

        .form-group-flex {
            flex: 1 1 100%;
            min-width: 0;
        }

        .form-group-add-btn .btn-add-fixed {
            width: 100%;
        }

        .custom-table-header {
            flex-direction: column;
            align-items: stretch;
        }
    }

    @media (max-width: 576px) {
        .modal-modern-header .header-text h2 {
            font-size: 22px;
        }

        .modal-modern-header .header-text p {
            font-size: 13px;
        }
    }

    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%) !important;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(45, 212, 191, 0.18) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modal-modern-body {
        background: transparent;
    }

    [data-bs-theme="dark"] .modern-modal .form-control {
        background-color: rgba(15, 23, 42, 0.8);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .modern-modal .form-control:focus {
            background-color: rgba(15, 23, 42, 0.95);
        }

    [data-bs-theme="dark"] .modern-modal select.form-control,
    [data-bs-theme="dark"] .modern-modal select.form-control:focus {
        background-color: rgba(15, 23, 42, 0.8);
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
    }

        [data-bs-theme="dark"] .modern-modal select.form-control:focus {
            background-color: rgba(15, 23, 42, 0.95);
        }

    [data-bs-theme="dark"] .modern-modal select.form-control option {
        background: #1f2937;
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-modal .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.25), transparent);
    }

    [data-bs-theme="dark"] .modal-modern-footer {
        background: transparent;
    }

    [data-bs-theme="dark"] .form-group-inline .info-chip {
        background: rgba(37, 99, 235, 0.15);
        color: #cbd5f5;
    }

    [data-bs-theme="dark"] .modern-modal small.text-muted {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

        [data-bs-theme="dark"] .btn-close-modern svg {
            color: #e2e8f0;
        }

        [data-bs-theme="dark"] .btn-close-modern:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        }

    [data-bs-theme="dark"] .btn-modern-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
    }

    [data-bs-theme="dark"] .modern-modal .form-control::placeholder {
        color: #64748b;
    }

    [data-bs-theme="dark"] .tab-btn.blocked {
        opacity: 0.4;
    }

    [data-bs-theme="dark"] .total-chip {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        border-color: #3b82f6;
        color: #93c5fd;
    }

        [data-bs-theme="dark"] .total-chip:hover {
            background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
        }

        [data-bs-theme="dark"] .total-chip.chip-active {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            border-color: #60a5fa;
            color: #ffffff;
        }

    [data-bs-theme="dark"] .section-card {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.9) 0%, rgba(30, 41, 59, 0.94) 100%);
        border-color: rgba(71, 85, 105, 0.55);
    }

    [data-bs-theme="dark"] .card-setor .setores-select-wrap :deep(.v-select .vs__selected) {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.25) 0%, rgba(37, 99, 235, 0.2) 100%) !important;
        border-color: rgba(96, 165, 250, 0.5) !important;
        color: #93c5fd !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }

    [data-bs-theme="dark"] .modern-btn-light {
        background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .modern-btn-light:hover {
            background: linear-gradient(135deg, #334155 0%, #475569 100%);
        }

    /* V-Select – tema escuro */
    [data-bs-theme="dark"] :deep(.v-select .vs__dropdown-toggle) {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] :deep(.v-select .vs__search) {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] :deep(.v-select .vs__search::placeholder) {
        color: #64748b;
    }

    [data-bs-theme="dark"] :deep(.v-select .vs__selected) {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] :deep(.v-select .vs__dropdown-menu) {
        background: rgba(15, 23, 42, 0.98);
        border-color: rgba(148, 163, 184, 0.25);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);
    }

    [data-bs-theme="dark"] :deep(.v-select .vs__dropdown-option) {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] :deep(.v-select .vs__dropdown-option:hover) {
        background: rgba(59, 130, 246, 0.2);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] :deep(.v-select .vs__dropdown-option--highlight) {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.3) 0%, rgba(59, 130, 246, 0.2) 100%);
        color: #93c5fd;
    }

    [data-bs-theme="dark"] :deep(.v-select .vs__open-indicator) {
        fill: #94a3b8;
    }

    [data-bs-theme="dark"] :deep(.v-select .vs__clear) {
        fill: #94a3b8;
    }

    [data-bs-theme="dark"] :deep(.v-select .vs__clear:hover) {
        fill: #f87171;
    }

    [data-bs-theme="dark"] .tabs-row {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(71, 85, 105, 0.55);
    }

    [data-bs-theme="dark"] .tab-btn {
        color: #94a3b8;
    }

        [data-bs-theme="dark"] .tab-btn:hover {
            background: rgba(59, 130, 246, 0.15);
            color: #93c5fd;
        }

        [data-bs-theme="dark"] .tab-btn.blocked:hover {
            background: transparent;
            color: #94a3b8;
        }

    [data-bs-theme="dark"] .modern-table .custom-table {
        border-color: rgba(71, 85, 105, 0.45);
    }

        [data-bs-theme="dark"] .modern-table .custom-table thead {
            background: linear-gradient(135deg, #111827 0%, #1f2937 100%);
        }

        [data-bs-theme="dark"] .modern-table .custom-table th,
        [data-bs-theme="dark"] .modern-table .custom-table td {
            color: #e2e8f0;
            border-bottom-color: rgba(71, 85, 105, 0.35);
        }

        [data-bs-theme="dark"] .modern-table .custom-table tbody tr:hover {
            background: rgba(59, 130, 246, 0.12);
        }

    [data-bs-theme="dark"] .item-name {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .item-details {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .card-setor .setor-label,
    [data-bs-theme="dark"] .card-setor .form-label {
        color: #e2e8f0;
    }
</style>
